import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Badge, Button, Card, CardBody, Col, Row, Table } from 'reactstrap'
import { presentAudit } from './audit-presentation'
import { auditDate, auditDiff } from './audit-diff'

const Snapshot = ({ title, rows }) => <Card className='h-100 mb-0'><CardBody>
  <h5>{title}</h5>
  {rows.length ? <Table size='sm' className='mb-0'><tbody>{rows.map((row) => <tr key={row.key}>
    <td className='text-muted' style={{ width: '40%' }}>{row.label}</td><td className='font-weight-bold'>{row.value}</td>
  </tr>)}</tbody></Table> : <p className='text-muted mb-0'>No {title.toLowerCase()} data available.</p>}
</CardBody></Card>
Snapshot.propTypes = { title: PropTypes.string.isRequired, rows: PropTypes.array.isRequired }

const AuditLogRow = ({ entry }) => {
  const [open, setOpen] = useState(false)
  const log = presentAudit(entry), diff = auditDiff(entry)
  const identity = log.details.find(([label]) => label === 'Item')?.[1] || log.details.find(([label]) => label === 'Assignment')?.[1] || log.details.find(([label]) => label === 'Member')?.[1] || '-'
  const actor = entry.done_by?.startsWith('system:') ? 'Automated system' : entry.done_by || 'Not recorded'
  return <>
    <tr style={open ? { backgroundColor: '#f6f9fc' } : undefined}>
      <td style={{ minWidth: 160 }}><strong>{identity}</strong><div className='small text-muted mt-1'>SKU / record identity</div></td>
      <td><Badge color={log.color}>{log.title}</Badge></td>
      <td style={{ minWidth: 280 }}>
        <div>{log.summary}</div><div className='small text-muted my-2'>{diff.changes.length} recorded change(s)</div>
        {diff.changes.slice(0, 3).map((row) => <div key={row.key} className='small mb-1'><strong>{row.label}: </strong>{row.before} → {row.after}</div>)}
        {diff.changes.length > 3 && <small className='text-muted'>+{diff.changes.length - 3} more change(s)</small>}
      </td>
      <td>{actor}</td><td style={{ minWidth: 150 }}>{auditDate(entry.created_at)}</td>
      <td><Button size='sm' color='info' outline aria-expanded={open} aria-controls={`ig-audit-detail-${entry.id}`} onClick={() => setOpen(!open)}>{open ? 'Hide' : 'View'}</Button></td>
    </tr>
    {open && <tr id={`ig-audit-detail-${entry.id}`}><td colSpan='6' style={{ backgroundColor: '#e5e9ef', padding: 20, whiteSpace: 'normal', overflowWrap: 'anywhere' }}>
      <Card className='mb-3'><CardBody><h5>Activity Summary</h5><p className='mb-1'>{log.summary}</p><small className='text-muted'>Performed by {actor} · {auditDate(entry.created_at)} WIB</small></CardBody></Card>
      <h5>Readable Before / After Diff</h5>
      <Table bordered responsive size='sm' className='bg-white mb-3'>
        <thead><tr><th style={{ width: '25%' }}>Field</th><th>Before</th><th>After</th></tr></thead>
        <tbody>{diff.changes.length ? diff.changes.map((row) => <tr key={row.key}><th scope='row'>{row.label}</th><td>{row.before}</td><td>{row.after}</td></tr>) : <tr><td colSpan='3' className='text-muted'>No value changes were recorded.</td></tr>}</tbody>
      </Table>
      <Row><Col md='6' className='mb-3 mb-md-0'><Snapshot title='Before' rows={diff.before} /></Col><Col md='6'><Snapshot title='After' rows={diff.after} /></Col></Row>
    </td></tr>}
  </>
}
AuditLogRow.propTypes = { entry: PropTypes.object.isRequired }
export default AuditLogRow
